<template>
    <dual-camera-upgrade-page />
</template>

<script>
import DualCameraUpgradePage from './dualCameraUpgrade/index.vue';

export default {
    name: 'DualCameraUpgradePageWrapper',
    components: {
        DualCameraUpgradePage
    }
};
</script>
